/**
 * @param {DataImage} dataImage
 * @returns {boolean}
 */
export default (dataImage) => dataImage?.data instanceof Uint16Array;
